// Date format used across the application
export const DATE_FORMAT = 'MM/dd/yyyy';

// FTC compliance quiet hours
export const QUIET_HOURS = {
  START: 20, // 8 PM
  END: 9 // 9 AM
} as const;

// Special timezone value for subscriber's local time
export const SUBSCRIBER_LOCAL_TIME = 'subscriber_local';

// North American Timezones following IANA timezone database
export const TIMEZONES = {
  [SUBSCRIBER_LOCAL_TIME]: "Subscriber's Local Time",
  'America/New_York': 'Eastern Time (ET)',
  'America/Chicago': 'Central Time (CT)',
  'America/Denver': 'Mountain Time (MT)',
  'America/Los_Angeles': 'Pacific Time (PT)',
  'America/Anchorage': 'Alaska Time (AKT)',
  'Pacific/Honolulu': 'Hawaii Standard Time (HST)'
} as const;

export type TimezoneKey = keyof typeof TIMEZONES;
export type ScheduleType = 'draft' | 'now' | 'schedule';
